import { useCallback } from 'react';
import { getVerifyProjectIdentifier } from '../api';

const checkIdentifier = async identifier => {
  try {
    return await getVerifyProjectIdentifier(identifier);
  } catch (error) {
    return console.log(error);
  }
};

export const formValidation = (fields, identifier = null, allEmpty = false) => {
  let errors = [];
  let errorFields = [];
  const regexForUrl = new RegExp('(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?');
  const homePageField = fields.find(field => field.fieldId === 'homepage');
  const requiredFields = allEmpty ? fields : fields.filter(field => field.fieldDefinition.isRequired);
  if (requiredFields.length > 0) {
    const emptyFields = requiredFields.filter(
      field =>
        field.valueId === null || field.valueId === '' || (Array.isArray(field.valueId) && field.valueId.length === 0),
    );
    errorFields = fields.map(field => {
      const condition = allEmpty
        ? field.valueId === null || field.valueId === ''
        : field.fieldDefinition.isRequired &&
          (field.valueId === null ||
            field.valueId === '' ||
            (Array.isArray(field.valueId) && field.valueId.length === 0));
      if (condition) {
        return { ...field, error: true };
      } else {
        field.error && delete field.error;
        return field;
      }
    });
    if (emptyFields.length > 0) {
      const findError = errors.find(error => error.type === 'required');
      findError === undefined && errors.push({ type: 'required', message: 'emptyFields' });
    } else {
      errors = errors.filter(error => error.type !== 'required');
    }
  }
  if (identifier !== null) {
    const findError = errors.find(error => error.type === 'identifier');
    if (identifier) {
      errors = errors.filter(error => error.type !== 'identifier');
    } else {
      findError === undefined && errors.push({ type: 'identifier', message: 'incorrectId' });
    }
  }
  if (homePageField !== undefined && homePageField.valueId !== null && homePageField.valueId !== '') {
    const findError = errors.find(error => error.type === 'homepage');
    if (regexForUrl.test(homePageField.valueId)) {
      errors = errors.filter(error => error.type !== 'homepage');
    } else {
      findError === undefined && errors.push({ type: 'homepage', message: 'urlError' });
    }
  }

  return {
    error: errors.length > 0,
    errors: errors,
    fields: errorFields,
  };
};
